import { combineReducers } from 'redux';
import { getSuccessActionType } from '../utils';
import { getErrorReducer, getStatusReducer } from './utils/generators';
import { FETCH_DECKS } from '../constants/deck';

function data(state = {}, action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_DECKS):
      return action.payload;

    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_DECKS]),
  error: getErrorReducer([FETCH_DECKS]),
  data
});
